import { Dispatch } from 'redux';
import { IState } from '@/state/IState';
import { DismissibleMessageKey, setMessageDismissal, getMessageDismissalValue } from '@/services/message-dismissal';
import { setMessageDismissalItem } from './actions';

export function loadMessageDismissal(key: DismissibleMessageKey, projectId: number | null) {
    return async function (dispatch: Dispatch, getState: () => IState) {
        const existingItem = getState().messageDismissals.items.find((x) => x.key === key && x.projectId === projectId);

        if (!existingItem) {
            dispatch(setMessageDismissalItem({ key, projectId, value: null }));
            const result = await getMessageDismissalValue(key, projectId);
            dispatch(setMessageDismissalItem({ key, projectId, value: result }));
        }
    };
}

export function updateMessageDismissal(key: DismissibleMessageKey, value: boolean, projectId: number | null) {
    return async function (dispatch: Dispatch, getState: () => IState) {
        await setMessageDismissal(key, value, projectId);
        dispatch(setMessageDismissalItem({ key, projectId, value }));
    };
}